import {PageTemplate} from "../../shared/layout/PageTemplate";
import {TendersContent} from "./components/TendersContent";

export function Tenders() {
    return <PageTemplate pageName="Tenders" title="Tenders" content={<TendersContent/>}/>

}